import { useEffect, useRef, useState } from 'react';

export const useValidateEmail = () => {
   const [code, setCode] = useState<string[]>(Array(6).fill(''));
   const [focus, setFocus] = useState<boolean[]>(
      Array(6)
         .fill(false)
         .map((_, i) => i === 0)
   );
   const inputRef = useRef<Array<HTMLInputElement | null>>(Array(6).fill(null));

   useEffect(() => {
      focus.forEach((isFocused, index) => {
         if (isFocused && inputRef.current[index]) {
            inputRef.current[index]?.focus();
         }
      });
   }, [focus]);

   const updateFocus = (index: number, direction: 'next' | 'prev') => {
      setFocus((prevFocus) => {
         const newFocus = Array(6).fill(false);
         if (direction === 'next' && index < 5) {
            newFocus[index + 1] = true;
         } else if (direction === 'prev' && index > 0) {
            newFocus[index - 1] = true;
         }
         return newFocus;
      });
   };

   const handlePaste = (e: any) => {
      e.preventDefault();
      const pasteData = e.clipboardData.getData('text').slice(0, 6);
      if (pasteData.length !== 6) return;
      const newCode = [];
      for (let i = 0; i < pasteData.length; i++) {
         if (!/^[0-9]*$/.test(pasteData[i])) return;
         newCode[i] = pasteData[i];
      }
      setCode(newCode);
   };

   const resetCode = () => {
      setCode(Array(6).fill(''));
      setFocus(
         Array(6)
            .fill(false)
            .map((_, i) => i === 0)
      );
   };

   return {
      code,
      setCode,
      handlePaste,
      updateFocus,
      inputRef,
      setFocus,
      resetCode,
   };
};
